module.exports = __webpack_public_path__ + "img/article7.e0b91dcc.jpeg";